const einDashboard = {
  einDashboard: {
    installingSince: 'Enphaseの設置開始年',
    accountManager: 'Enphase Account Manager',
    installationShare: 'Enphase設置のシェア',
    nps: 'ネット・プロモーター・スコア',
    viewDashboard: 'ダッシュボードを見る',
    quarterInfo: 'Q %{quarter}、%{year} 時点 (住宅)',
    npsTooltip: `ネット・プロモーター・スコア（Net Promoter Score）とは、顧客が会社の製品やサービスを他の人に薦める意欲を測る-100から100までの指数です。このスコアは、Enlightenモバイルアプリでお客様が貴社のサービスにつけた評価に基づいており、貴社とEnphaseのみが見ることができます。データのデフォルト期間は過去13ヶ月です。`,
    activity: 'アクティビティ',
    sites: 'ソーラーサイト',
    batteries: 'バッテリー',
    acb: 'ACB',
    certifications: '認証',
    community: 'コミュニティ',
    storage: '保管場所',
    lastInstalledLabel: '過去12ヶ月間に設置',
    lastCommissionedLabel: '過去12ヶ月間に委託',
    viewDetails: '詳細を見る',
    seeReviews: 'レビューを見る',
    viewCommunity: 'コミュニティを見る',
    certificateLabel: '%{count} / %{totalCount} が認証取得',
    networkLabel: {
      one: '%{count} 件の投稿、最後の投稿：%{postDate}',
      other: '%{count} 件の投稿、最後の投稿：%{postDate}'
    },
    requestProductAccess: '製品へのアクセスをリクエスト',
    inverter: 'IQ-8',
    ensemble: 'Ensemble 2.0',
    permit: '許可支援',
    sgip: 'SGIP支援',
    learnMore: '詳細',
    aboutProduct: '製品について',
    betaReleaseDate: 'ベータ版リリース日',
    requestEarlyAccess: 'アーリーアクセスをリクエスト',
    viewAllProduct: 'すべての製品を見る',
    signUp: '登録する',
    betaReleaseLabel: 'すべての新しいベータ版製品リリースについて',
    financing: '資金調達サポート',
    digitalPlatform: 'デジタルプラットフォーム',
    lpp: 'LPP',
    requestedText: 'アーリーアクセスへのリクエストが送信されました',
    grantedText: 'ベータ版へのアクセスが許可されました',
    products: '製品',
    ratingsReviews: '評価＆レビュー',
    reviews: 'レビュー',
    otherReviews: 'その他のレビュー',
    updateDetails: '更新の詳細',
    totalSavings: '総節約額',
    inLastYear: '過去12ヶ月間',
    viewBreakdown: '内訳を見る',
    leadsReceived: '獲得リード数',
    leadsClosure: 'クローズしたリード数',
    leadsWon: '獲得したリード数',
    creditAvailable: 'クレジット利用可能',
    buyMore: 'まとめ買い',
    messageFromCeo: 'CEOからのメッセージ',
    communityUpdates: 'コミュニティの最新情報',
    makeAppointments: '予約を取る',
    applicableText: 'プラチナ会員のみに適用',
    view: '表示',
    downloadAll: 'すべてダウンロード',
    promoteText: 'バッジやロゴで会社をアピール',
    asOfText: '現在：%{date}',
    yearTotal: '合計／年',
    redeemed: '換金済み',
    laborProtectionPlan: '労働者保護プログラム',
    acmPromotion: 'ACMプロモーション',
    save: {
      lre_data: 'LPPによる節約',
      permit_data: '許可による節約',
      financing_data: '融資による節約',
      sgip_data: 'SGIPによる節約',
      warrantyExtension: '保証延長の節約'
    },
    platinumLogo: 'プラチナロゴ',
    enphaseLogo: 'Enphaseロゴ',
    otherAssets: 'その他の資産',
    ensembleCertificate: 'Ensemble認定',
    salesCertificate: 'Sales 1.0認定',
    marketingCertificate: 'Marketing 1.0認定',
    solarInstallCertificate: 'ソーラー設置認定',
    validTill: '有効期限：%{date}',
    noDataAvailable: '該当データなし',
    notAvailable: '利用不可',
    notApplicable: '該当なし',
    title: 'EINダッシュボード',
    congratulationSignUp: 'おめでとうございます。Enphaseの新製品/サービスをいち早くご覧いただけます',
    benefits: 'メリット',
    installationShareTooltip:
      'この数字は、Enphaseの設置が全体の何パーセントを占めているかを示しています。',
    dataFromThirdParty: '*サードパーティのデータによる',
    reviewsNotAvailable: 'レビューは利用できません',
    enphaseExecutive: 'Enphaseエグゼクティブ',
    digitalAssets: 'デジタル資産',
    leads: 'リード',
    tierSavings: 'ティアによる節約',
    exclusiveUpdates: '独占アップデート',
    executiveSponsor: 'エグゼクティブスポンサー',
    merchandise: '商品',
    certifiedUsers: '認定ユーザー',
    noteAllowedOnce: '備考：上記リンクは一度作成されると編集できません。',
    saveLink: `リンクを保存`,
    confirm: `確認`,
    copyLink: 'リンクをコピー',
    allowedCharactersError: '半角英数字、ハイフン、アンダースコアのみ使用可能（500文字以内）',
    createSystemEstimatorLink: `パーソナライズされたシステム見積もりリンクを作成し、顧客と共有することで、顧客からリードを得ることができます。このリンクから生成されたリードは、Enlighten Managerでユーザーとのみ共有されます。`,
    shareSystemEstimatorLink: `パーソナライズされたシステム見積もりリンクを顧客と共有し、顧客からリードを獲得しましょう。このリンクから生成されたリードは、Enlighten Managerでユーザーとのみ共有されます。`,
    systemEstimatorLink: 'システム見積もりリンク',
    confirmChanges: '変更の確認',
    confirmSELink: 'システム見積もりリンクをご確認ください。このリンクは一度保存すると編集できません。',
    copied: `コピーしました`,
    mySELink: '自分のシステム見積もりリンク',
    sdtUrlExistsError: 'このリンクはすでに別の設置業者によって使用されています。別のリンクを選択してください',
    all: 'すべて',
    filterText: 'フィルター',
    noProductAvailable: '該当製品がありません'
  }
};

export default einDashboard;
